import { l as fa, g as ca, i as pa, b as da, p as ma, k as Er, f as va, d as Ar } from "./keys-CQjWNUL0.mjs";
import { b as _a, i as yr } from "./correct-is-regexp-logic-DUuS52mu.mjs";
import { r as ha, a as Ta, b as ga, c as br, d as Ea, e as Sr, f as Aa, g as ya, h as ba, i as Sa, j as Ra, k as xa, l as Oa } from "./compact-CN4wKJco.mjs";
import { d as Ia, e as Rr, f as La, g as Ca, c as Ma } from "./_arrayPush-DUvcoEi5.mjs";
import { c as wa } from "./_commonjsHelpers-BkfeUUK-.mjs";
var Na = {}, Qt = {}, ut, er;
function Da() {
  if (er) return ut;
  er = 1;
  var u = fa, v = ca, i = pa, y = _a(), I = ha().trim, T = Ta(), _ = u.parseInt, P = u.Symbol, G = P && P.iterator, j = /^[+-]?0x/i, C = i(j.exec), R = _(T + "08") !== 8 || _(T + "0x16") !== 22 || G && !v(function() {
    _(Object(G));
  });
  return ut = R ? function(A, M) {
    var U = I(y(A));
    return _(U, M >>> 0 || (C(j, U) ? 16 : 10));
  } : _, ut;
}
var tr;
function Pa() {
  if (tr) return Qt;
  tr = 1;
  var u = da(), v = Da();
  return u({ global: !0, forced: parseInt !== v }, {
    parseInt: v
  }), Qt;
}
var st, rr;
function Fa() {
  if (rr) return st;
  rr = 1, Pa();
  var u = ma;
  return st = u.parseInt, st;
}
var lt, ar;
function Ua() {
  if (ar) return lt;
  ar = 1;
  var u = Fa();
  return lt = u, lt;
}
var ft, nr;
function ka() {
  if (nr) return ft;
  nr = 1;
  var u = Ua();
  return ft = u, ft;
}
var ct, ir;
function qa() {
  if (ir) return ct;
  ir = 1;
  var u = ka();
  return ct = u, ct;
}
var pt, or;
function Ha() {
  return or || (or = 1, pt = qa()), pt;
}
var dt, ur;
function Wa() {
  return ur || (ur = 1, dt = Ha()), dt;
}
var mt, sr;
function za() {
  if (sr) return mt;
  sr = 1;
  function u(v, i, y, I) {
    var T = -1, _ = v == null ? 0 : v.length;
    for (I && _ && (y = v[++T]); ++T < _; )
      y = i(y, v[T], T, v);
    return y;
  }
  return mt = u, mt;
}
var vt, lr;
function $a() {
  if (lr) return vt;
  lr = 1;
  var u = ga(), v = {
    // Latin-1 Supplement block.
    À: "A",
    Á: "A",
    Â: "A",
    Ã: "A",
    Ä: "A",
    Å: "A",
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    ä: "a",
    å: "a",
    Ç: "C",
    ç: "c",
    Ð: "D",
    ð: "d",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    Ì: "I",
    Í: "I",
    Î: "I",
    Ï: "I",
    ì: "i",
    í: "i",
    î: "i",
    ï: "i",
    Ñ: "N",
    ñ: "n",
    Ò: "O",
    Ó: "O",
    Ô: "O",
    Õ: "O",
    Ö: "O",
    Ø: "O",
    ò: "o",
    ó: "o",
    ô: "o",
    õ: "o",
    ö: "o",
    ø: "o",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    Ý: "Y",
    ý: "y",
    ÿ: "y",
    Æ: "Ae",
    æ: "ae",
    Þ: "Th",
    þ: "th",
    ß: "ss",
    // Latin Extended-A block.
    Ā: "A",
    Ă: "A",
    Ą: "A",
    ā: "a",
    ă: "a",
    ą: "a",
    Ć: "C",
    Ĉ: "C",
    Ċ: "C",
    Č: "C",
    ć: "c",
    ĉ: "c",
    ċ: "c",
    č: "c",
    Ď: "D",
    Đ: "D",
    ď: "d",
    đ: "d",
    Ē: "E",
    Ĕ: "E",
    Ė: "E",
    Ę: "E",
    Ě: "E",
    ē: "e",
    ĕ: "e",
    ė: "e",
    ę: "e",
    ě: "e",
    Ĝ: "G",
    Ğ: "G",
    Ġ: "G",
    Ģ: "G",
    ĝ: "g",
    ğ: "g",
    ġ: "g",
    ģ: "g",
    Ĥ: "H",
    Ħ: "H",
    ĥ: "h",
    ħ: "h",
    Ĩ: "I",
    Ī: "I",
    Ĭ: "I",
    Į: "I",
    İ: "I",
    ĩ: "i",
    ī: "i",
    ĭ: "i",
    į: "i",
    ı: "i",
    Ĵ: "J",
    ĵ: "j",
    Ķ: "K",
    ķ: "k",
    ĸ: "k",
    Ĺ: "L",
    Ļ: "L",
    Ľ: "L",
    Ŀ: "L",
    Ł: "L",
    ĺ: "l",
    ļ: "l",
    ľ: "l",
    ŀ: "l",
    ł: "l",
    Ń: "N",
    Ņ: "N",
    Ň: "N",
    Ŋ: "N",
    ń: "n",
    ņ: "n",
    ň: "n",
    ŋ: "n",
    Ō: "O",
    Ŏ: "O",
    Ő: "O",
    ō: "o",
    ŏ: "o",
    ő: "o",
    Ŕ: "R",
    Ŗ: "R",
    Ř: "R",
    ŕ: "r",
    ŗ: "r",
    ř: "r",
    Ś: "S",
    Ŝ: "S",
    Ş: "S",
    Š: "S",
    ś: "s",
    ŝ: "s",
    ş: "s",
    š: "s",
    Ţ: "T",
    Ť: "T",
    Ŧ: "T",
    ţ: "t",
    ť: "t",
    ŧ: "t",
    Ũ: "U",
    Ū: "U",
    Ŭ: "U",
    Ů: "U",
    Ű: "U",
    Ų: "U",
    ũ: "u",
    ū: "u",
    ŭ: "u",
    ů: "u",
    ű: "u",
    ų: "u",
    Ŵ: "W",
    ŵ: "w",
    Ŷ: "Y",
    ŷ: "y",
    Ÿ: "Y",
    Ź: "Z",
    Ż: "Z",
    Ž: "Z",
    ź: "z",
    ż: "z",
    ž: "z",
    Ĳ: "IJ",
    ĳ: "ij",
    Œ: "Oe",
    œ: "oe",
    ŉ: "'n",
    ſ: "s"
  }, i = u(v);
  return vt = i, vt;
}
var _t, fr;
function Ga() {
  if (fr) return _t;
  fr = 1;
  var u = $a(), v = br(), i = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, y = "\\u0300-\\u036f", I = "\\ufe20-\\ufe2f", T = "\\u20d0-\\u20ff", _ = y + I + T, P = "[" + _ + "]", G = RegExp(P, "g");
  function j(C) {
    return C = v(C), C && C.replace(i, u).replace(G, "");
  }
  return _t = j, _t;
}
var ht, cr;
function Ba() {
  if (cr) return ht;
  cr = 1;
  var u = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  function v(i) {
    return i.match(u) || [];
  }
  return ht = v, ht;
}
var Tt, pr;
function ja() {
  if (pr) return Tt;
  pr = 1;
  var u = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  function v(i) {
    return u.test(i);
  }
  return Tt = v, Tt;
}
var gt, dr;
function Va() {
  if (dr) return gt;
  dr = 1;
  var u = "\\ud800-\\udfff", v = "\\u0300-\\u036f", i = "\\ufe20-\\ufe2f", y = "\\u20d0-\\u20ff", I = v + i + y, T = "\\u2700-\\u27bf", _ = "a-z\\xdf-\\xf6\\xf8-\\xff", P = "\\xac\\xb1\\xd7\\xf7", G = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", j = "\\u2000-\\u206f", C = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", R = "A-Z\\xc0-\\xd6\\xd8-\\xde", S = "\\ufe0e\\ufe0f", A = P + G + j + C, M = "['’]", U = "[" + A + "]", Z = "[" + I + "]", x = "\\d+", k = "[" + T + "]", ee = "[" + _ + "]", te = "[^" + u + A + x + T + _ + R + "]", X = "\\ud83c[\\udffb-\\udfff]", re = "(?:" + Z + "|" + X + ")", le = "[^" + u + "]", ne = "(?:\\ud83c[\\udde6-\\uddff]){2}", l = "[\\ud800-\\udbff][\\udc00-\\udfff]", c = "[" + R + "]", h = "\\u200d", o = "(?:" + ee + "|" + te + ")", f = "(?:" + c + "|" + te + ")", g = "(?:" + M + "(?:d|ll|m|re|s|t|ve))?", O = "(?:" + M + "(?:D|LL|M|RE|S|T|VE))?", m = re + "?", L = "[" + S + "]?", N = "(?:" + h + "(?:" + [le, ne, l].join("|") + ")" + L + m + ")*", V = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", d = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", z = L + m + N, me = "(?:" + [k, ne, l].join("|") + ")" + z, Oe = RegExp([
    c + "?" + ee + "+" + g + "(?=" + [U, c, "$"].join("|") + ")",
    f + "+" + O + "(?=" + [U, c + o, "$"].join("|") + ")",
    c + "?" + o + "+" + g,
    c + "+" + O,
    d,
    V,
    x,
    me
  ].join("|"), "g");
  function Ae(ye) {
    return ye.match(Oe) || [];
  }
  return gt = Ae, gt;
}
var Et, mr;
function Za() {
  if (mr) return Et;
  mr = 1;
  var u = Ba(), v = ja(), i = br(), y = Va();
  function I(T, _, P) {
    return T = i(T), _ = P ? void 0 : _, _ === void 0 ? v(T) ? y(T) : u(T) : T.match(_) || [];
  }
  return Et = I, Et;
}
var At, vr;
function Ya() {
  if (vr) return At;
  vr = 1;
  var u = za(), v = Ga(), i = Za(), y = "['’]", I = RegExp(y, "g");
  function T(_) {
    return function(P) {
      return u(i(v(P).replace(I, "")), _, "");
    };
  }
  return At = T, At;
}
var yt, _r;
function Xa() {
  if (_r) return yt;
  _r = 1;
  var u = Ya(), v = u(function(i, y, I) {
    return i + (I ? "-" : "") + y.toLowerCase();
  });
  return yt = v, yt;
}
var bt = { exports: {} };
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
var hr;
function xr() {
  return hr || (hr = 1, function(u) {
    (function() {
      var v = function() {
        function i() {
        }
        i.prototype = /* @__PURE__ */ Object.create(null);
        function y(R, S) {
          for (var A = S.length, M = 0; M < A; ++M)
            j(R, S[M]);
        }
        var I = {}.hasOwnProperty;
        function T(R, S) {
          R[S] = !0;
        }
        function _(R, S) {
          for (var A in S)
            I.call(S, A) && (R[A] = !!S[A]);
        }
        var P = /\s+/;
        function G(R, S) {
          for (var A = S.split(P), M = A.length, U = 0; U < M; ++U)
            R[A[U]] = !0;
        }
        function j(R, S) {
          if (S) {
            var A = typeof S;
            A === "string" ? G(R, S) : Array.isArray(S) ? y(R, S) : A === "object" ? _(R, S) : A === "number" && T(R, S);
          }
        }
        function C() {
          for (var R = arguments.length, S = Array(R), A = 0; A < R; A++)
            S[A] = arguments[A];
          var M = new i();
          y(M, S);
          var U = [];
          for (var Z in M)
            M[Z] && U.push(Z);
          return U.join(" ");
        }
        return C;
      }();
      u.exports ? (v.default = v, u.exports = v) : window.classNames = v;
    })();
  }(bt)), bt.exports;
}
var St = { exports: {} };
/*! @license DOMPurify 2.5.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.8/LICENSE */
var Tr;
function Ka() {
  return Tr || (Tr = 1, function(u, v) {
    (function(i, y) {
      u.exports = y();
    })(wa, function() {
      function i(a) {
        "@babel/helpers - typeof";
        return i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
          return typeof n;
        } : function(n) {
          return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
        }, i(a);
      }
      function y(a, n) {
        return y = Object.setPrototypeOf || function(E, D) {
          return E.__proto__ = D, E;
        }, y(a, n);
      }
      function I() {
        if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
        if (typeof Proxy == "function") return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
          })), !0;
        } catch {
          return !1;
        }
      }
      function T(a, n, p) {
        return I() ? T = Reflect.construct : T = function(D, J, K) {
          var ie = [null];
          ie.push.apply(ie, J);
          var fe = Function.bind.apply(D, ie), be = new fe();
          return K && y(be, K.prototype), be;
        }, T.apply(null, arguments);
      }
      function _(a) {
        return P(a) || G(a) || j(a) || R();
      }
      function P(a) {
        if (Array.isArray(a)) return C(a);
      }
      function G(a) {
        if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
      }
      function j(a, n) {
        if (a) {
          if (typeof a == "string") return C(a, n);
          var p = Object.prototype.toString.call(a).slice(8, -1);
          if (p === "Object" && a.constructor && (p = a.constructor.name), p === "Map" || p === "Set") return Array.from(a);
          if (p === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(p)) return C(a, n);
        }
      }
      function C(a, n) {
        (n == null || n > a.length) && (n = a.length);
        for (var p = 0, E = new Array(n); p < n; p++) E[p] = a[p];
        return E;
      }
      function R() {
        throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var S = Object.hasOwnProperty, A = Object.setPrototypeOf, M = Object.isFrozen, U = Object.getPrototypeOf, Z = Object.getOwnPropertyDescriptor, x = Object.freeze, k = Object.seal, ee = Object.create, te = typeof Reflect < "u" && Reflect, X = te.apply, re = te.construct;
      X || (X = function(n, p, E) {
        return n.apply(p, E);
      }), x || (x = function(n) {
        return n;
      }), k || (k = function(n) {
        return n;
      }), re || (re = function(n, p) {
        return T(n, _(p));
      });
      var le = N(Array.prototype.forEach), ne = N(Array.prototype.pop), l = N(Array.prototype.push), c = N(String.prototype.toLowerCase), h = N(String.prototype.toString), o = N(String.prototype.match), f = N(String.prototype.replace), g = N(String.prototype.indexOf), O = N(String.prototype.trim), m = N(RegExp.prototype.test), L = V(TypeError);
      function N(a) {
        return function(n) {
          for (var p = arguments.length, E = new Array(p > 1 ? p - 1 : 0), D = 1; D < p; D++)
            E[D - 1] = arguments[D];
          return X(a, n, E);
        };
      }
      function V(a) {
        return function() {
          for (var n = arguments.length, p = new Array(n), E = 0; E < n; E++)
            p[E] = arguments[E];
          return re(a, p);
        };
      }
      function d(a, n, p) {
        var E;
        p = (E = p) !== null && E !== void 0 ? E : c, A && A(a, null);
        for (var D = n.length; D--; ) {
          var J = n[D];
          if (typeof J == "string") {
            var K = p(J);
            K !== J && (M(n) || (n[D] = K), J = K);
          }
          a[J] = !0;
        }
        return a;
      }
      function z(a) {
        var n = ee(null), p;
        for (p in a)
          X(S, a, [p]) === !0 && (n[p] = a[p]);
        return n;
      }
      function me(a, n) {
        for (; a !== null; ) {
          var p = Z(a, n);
          if (p) {
            if (p.get)
              return N(p.get);
            if (typeof p.value == "function")
              return N(p.value);
          }
          a = U(a);
        }
        function E(D) {
          return console.warn("fallback value for", D), null;
        }
        return E;
      }
      var Oe = x(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Ae = x(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), ye = x(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Or = x(["animate", "color-profile", "cursor", "discard", "fedropshadow", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), ke = x(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover"]), Ir = x(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), xt = x(["#text"]), Ot = x(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]), qe = x(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), It = x(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Ie = x(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Lr = k(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Cr = k(/<%[\w\W]*|[\w\W]*%>/gm), Mr = k(/\${[\w\W]*}/gm), wr = k(/^data-[\-\w.\u00B7-\uFFFF]+$/), Nr = k(/^aria-[\-\w]+$/), Dr = k(
        /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
        // eslint-disable-line no-useless-escape
      ), Pr = k(/^(?:\w+script|data):/i), Fr = k(
        /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
        // eslint-disable-line no-control-regex
      ), Ur = k(/^html$/i), kr = k(/^[a-z][.\w]*(-[.\w]+)+$/i), qr = function() {
        return typeof window > "u" ? null : window;
      }, Hr = function(n, p) {
        if (i(n) !== "object" || typeof n.createPolicy != "function")
          return null;
        var E = null, D = "data-tt-policy-suffix";
        p.currentScript && p.currentScript.hasAttribute(D) && (E = p.currentScript.getAttribute(D));
        var J = "dompurify" + (E ? "#" + E : "");
        try {
          return n.createPolicy(J, {
            createHTML: function(ie) {
              return ie;
            },
            createScriptURL: function(ie) {
              return ie;
            }
          });
        } catch {
          return console.warn("TrustedTypes policy " + J + " could not be created."), null;
        }
      };
      function Lt() {
        var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : qr(), n = function(e) {
          return Lt(e);
        };
        if (n.version = "2.5.8", n.removed = [], !a || !a.document || a.document.nodeType !== 9)
          return n.isSupported = !1, n;
        var p = a.document, E = a.document, D = a.DocumentFragment, J = a.HTMLTemplateElement, K = a.Node, ie = a.Element, fe = a.NodeFilter, be = a.NamedNodeMap, zr = be === void 0 ? a.NamedNodeMap || a.MozNamedAttrMap : be, $r = a.HTMLFormElement, Gr = a.DOMParser, Le = a.trustedTypes, Ce = ie.prototype, Br = me(Ce, "cloneNode"), jr = me(Ce, "nextSibling"), Vr = me(Ce, "childNodes"), He = me(Ce, "parentNode");
        if (typeof J == "function") {
          var We = E.createElement("template");
          We.content && We.content.ownerDocument && (E = We.content.ownerDocument);
        }
        var ae = Hr(Le, p), ze = ae ? ae.createHTML("") : "", Me = E, $e = Me.implementation, Zr = Me.createNodeIterator, Yr = Me.createDocumentFragment, Xr = Me.getElementsByTagName, Kr = p.importNode, Ct = {};
        try {
          Ct = z(E).documentMode ? E.documentMode : {};
        } catch {
        }
        var oe = {};
        n.isSupported = typeof He == "function" && $e && $e.createHTMLDocument !== void 0 && Ct !== 9;
        var Ge = Lr, Be = Cr, je = Mr, Jr = wr, Qr = Nr, ea = Pr, Mt = Fr, ta = kr, Ve = Dr, q = null, wt = d({}, [].concat(_(Oe), _(Ae), _(ye), _(ke), _(xt))), H = null, Nt = d({}, [].concat(_(Ot), _(qe), _(It), _(Ie))), w = Object.seal(Object.create(null, {
          tagNameCheck: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: null
          },
          attributeNameCheck: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: null
          },
          allowCustomizedBuiltInElements: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: !1
          }
        })), Se = null, Ze = null, Dt = !0, Ye = !0, Pt = !1, Ft = !0, ve = !1, Xe = !0, ce = !1, Ke = !1, Je = !1, _e = !1, we = !1, Ne = !1, Ut = !0, kt = !1, ra = "user-content-", Qe = !0, Re = !1, he = {}, Te = null, qt = d({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]), Ht = null, Wt = d({}, ["audio", "video", "img", "source", "image", "track"]), et = null, zt = d({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), De = "http://www.w3.org/1998/Math/MathML", Pe = "http://www.w3.org/2000/svg", ue = "http://www.w3.org/1999/xhtml", ge = ue, tt = !1, rt = null, aa = d({}, [De, Pe, ue], h), pe, na = ["application/xhtml+xml", "text/html"], ia = "text/html", W, Ee = null, oa = E.createElement("form"), $t = function(e) {
          return e instanceof RegExp || e instanceof Function;
        }, at = function(e) {
          Ee && Ee === e || ((!e || i(e) !== "object") && (e = {}), e = z(e), pe = // eslint-disable-next-line unicorn/prefer-includes
          na.indexOf(e.PARSER_MEDIA_TYPE) === -1 ? pe = ia : pe = e.PARSER_MEDIA_TYPE, W = pe === "application/xhtml+xml" ? h : c, q = "ALLOWED_TAGS" in e ? d({}, e.ALLOWED_TAGS, W) : wt, H = "ALLOWED_ATTR" in e ? d({}, e.ALLOWED_ATTR, W) : Nt, rt = "ALLOWED_NAMESPACES" in e ? d({}, e.ALLOWED_NAMESPACES, h) : aa, et = "ADD_URI_SAFE_ATTR" in e ? d(
            z(zt),
            // eslint-disable-line indent
            e.ADD_URI_SAFE_ATTR,
            // eslint-disable-line indent
            W
            // eslint-disable-line indent
          ) : zt, Ht = "ADD_DATA_URI_TAGS" in e ? d(
            z(Wt),
            // eslint-disable-line indent
            e.ADD_DATA_URI_TAGS,
            // eslint-disable-line indent
            W
            // eslint-disable-line indent
          ) : Wt, Te = "FORBID_CONTENTS" in e ? d({}, e.FORBID_CONTENTS, W) : qt, Se = "FORBID_TAGS" in e ? d({}, e.FORBID_TAGS, W) : {}, Ze = "FORBID_ATTR" in e ? d({}, e.FORBID_ATTR, W) : {}, he = "USE_PROFILES" in e ? e.USE_PROFILES : !1, Dt = e.ALLOW_ARIA_ATTR !== !1, Ye = e.ALLOW_DATA_ATTR !== !1, Pt = e.ALLOW_UNKNOWN_PROTOCOLS || !1, Ft = e.ALLOW_SELF_CLOSE_IN_ATTR !== !1, ve = e.SAFE_FOR_TEMPLATES || !1, Xe = e.SAFE_FOR_XML !== !1, ce = e.WHOLE_DOCUMENT || !1, _e = e.RETURN_DOM || !1, we = e.RETURN_DOM_FRAGMENT || !1, Ne = e.RETURN_TRUSTED_TYPE || !1, Je = e.FORCE_BODY || !1, Ut = e.SANITIZE_DOM !== !1, kt = e.SANITIZE_NAMED_PROPS || !1, Qe = e.KEEP_CONTENT !== !1, Re = e.IN_PLACE || !1, Ve = e.ALLOWED_URI_REGEXP || Ve, ge = e.NAMESPACE || ue, w = e.CUSTOM_ELEMENT_HANDLING || {}, e.CUSTOM_ELEMENT_HANDLING && $t(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (w.tagNameCheck = e.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e.CUSTOM_ELEMENT_HANDLING && $t(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (w.attributeNameCheck = e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e.CUSTOM_ELEMENT_HANDLING && typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (w.allowCustomizedBuiltInElements = e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), ve && (Ye = !1), we && (_e = !0), he && (q = d({}, _(xt)), H = [], he.html === !0 && (d(q, Oe), d(H, Ot)), he.svg === !0 && (d(q, Ae), d(H, qe), d(H, Ie)), he.svgFilters === !0 && (d(q, ye), d(H, qe), d(H, Ie)), he.mathMl === !0 && (d(q, ke), d(H, It), d(H, Ie))), e.ADD_TAGS && (q === wt && (q = z(q)), d(q, e.ADD_TAGS, W)), e.ADD_ATTR && (H === Nt && (H = z(H)), d(H, e.ADD_ATTR, W)), e.ADD_URI_SAFE_ATTR && d(et, e.ADD_URI_SAFE_ATTR, W), e.FORBID_CONTENTS && (Te === qt && (Te = z(Te)), d(Te, e.FORBID_CONTENTS, W)), Qe && (q["#text"] = !0), ce && d(q, ["html", "head", "body"]), q.table && (d(q, ["tbody"]), delete Se.tbody), x && x(e), Ee = e);
        }, Gt = d({}, ["mi", "mo", "mn", "ms", "mtext"]), Bt = d({}, ["annotation-xml"]), ua = d({}, ["title", "style", "font", "a", "script"]), Fe = d({}, Ae);
        d(Fe, ye), d(Fe, Or);
        var nt = d({}, ke);
        d(nt, Ir);
        var sa = function(e) {
          var t = He(e);
          (!t || !t.tagName) && (t = {
            namespaceURI: ge,
            tagName: "template"
          });
          var r = c(e.tagName), b = c(t.tagName);
          return rt[e.namespaceURI] ? e.namespaceURI === Pe ? t.namespaceURI === ue ? r === "svg" : t.namespaceURI === De ? r === "svg" && (b === "annotation-xml" || Gt[b]) : !!Fe[r] : e.namespaceURI === De ? t.namespaceURI === ue ? r === "math" : t.namespaceURI === Pe ? r === "math" && Bt[b] : !!nt[r] : e.namespaceURI === ue ? t.namespaceURI === Pe && !Bt[b] || t.namespaceURI === De && !Gt[b] ? !1 : !nt[r] && (ua[r] || !Fe[r]) : !!(pe === "application/xhtml+xml" && rt[e.namespaceURI]) : !1;
        }, Q = function(e) {
          l(n.removed, {
            element: e
          });
          try {
            e.parentNode.removeChild(e);
          } catch {
            try {
              e.outerHTML = ze;
            } catch {
              e.remove();
            }
          }
        }, Ue = function(e, t) {
          try {
            l(n.removed, {
              attribute: t.getAttributeNode(e),
              from: t
            });
          } catch {
            l(n.removed, {
              attribute: null,
              from: t
            });
          }
          if (t.removeAttribute(e), e === "is" && !H[e])
            if (_e || we)
              try {
                Q(t);
              } catch {
              }
            else
              try {
                t.setAttribute(e, "");
              } catch {
              }
        }, jt = function(e) {
          var t, r;
          if (Je)
            e = "<remove></remove>" + e;
          else {
            var b = o(e, /^[\r\n\t ]+/);
            r = b && b[0];
          }
          pe === "application/xhtml+xml" && ge === ue && (e = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e + "</body></html>");
          var Y = ae ? ae.createHTML(e) : e;
          if (ge === ue)
            try {
              t = new Gr().parseFromString(Y, pe);
            } catch {
            }
          if (!t || !t.documentElement) {
            t = $e.createDocument(ge, "template", null);
            try {
              t.documentElement.innerHTML = tt ? ze : Y;
            } catch {
            }
          }
          var B = t.body || t.documentElement;
          return e && r && B.insertBefore(E.createTextNode(r), B.childNodes[0] || null), ge === ue ? Xr.call(t, ce ? "html" : "body")[0] : ce ? t.documentElement : B;
        }, Vt = function(e) {
          return Zr.call(
            e.ownerDocument || e,
            e,
            // eslint-disable-next-line no-bitwise
            fe.SHOW_ELEMENT | fe.SHOW_COMMENT | fe.SHOW_TEXT | fe.SHOW_PROCESSING_INSTRUCTION | fe.SHOW_CDATA_SECTION,
            null,
            !1
          );
        }, it = function(e) {
          return e instanceof $r && (typeof e.nodeName != "string" || typeof e.textContent != "string" || typeof e.removeChild != "function" || !(e.attributes instanceof zr) || typeof e.removeAttribute != "function" || typeof e.setAttribute != "function" || typeof e.namespaceURI != "string" || typeof e.insertBefore != "function" || typeof e.hasChildNodes != "function");
        }, xe = function(e) {
          return i(K) === "object" ? e instanceof K : e && i(e) === "object" && typeof e.nodeType == "number" && typeof e.nodeName == "string";
        }, se = function(e, t, r) {
          oe[e] && le(oe[e], function(b) {
            b.call(n, t, r, Ee);
          });
        }, Zt = function(e) {
          var t;
          if (se("beforeSanitizeElements", e, null), it(e) || m(/[\u0080-\uFFFF]/, e.nodeName))
            return Q(e), !0;
          var r = W(e.nodeName);
          if (se("uponSanitizeElement", e, {
            tagName: r,
            allowedTags: q
          }), e.hasChildNodes() && !xe(e.firstElementChild) && (!xe(e.content) || !xe(e.content.firstElementChild)) && m(/<[/\w]/g, e.innerHTML) && m(/<[/\w]/g, e.textContent) || r === "select" && m(/<template/i, e.innerHTML) || e.nodeType === 7 || Xe && e.nodeType === 8 && m(/<[/\w]/g, e.data))
            return Q(e), !0;
          if (!q[r] || Se[r]) {
            if (!Se[r] && Xt(r) && (w.tagNameCheck instanceof RegExp && m(w.tagNameCheck, r) || w.tagNameCheck instanceof Function && w.tagNameCheck(r)))
              return !1;
            if (Qe && !Te[r]) {
              var b = He(e) || e.parentNode, Y = Vr(e) || e.childNodes;
              if (Y && b)
                for (var B = Y.length, $ = B - 1; $ >= 0; --$) {
                  var de = Br(Y[$], !0);
                  de.__removalCount = (e.__removalCount || 0) + 1, b.insertBefore(de, jr(e));
                }
            }
            return Q(e), !0;
          }
          return e instanceof ie && !sa(e) || (r === "noscript" || r === "noembed" || r === "noframes") && m(/<\/no(script|embed|frames)/i, e.innerHTML) ? (Q(e), !0) : (ve && e.nodeType === 3 && (t = e.textContent, t = f(t, Ge, " "), t = f(t, Be, " "), t = f(t, je, " "), e.textContent !== t && (l(n.removed, {
            element: e.cloneNode()
          }), e.textContent = t)), se("afterSanitizeElements", e, null), !1);
        }, Yt = function(e, t, r) {
          if (Ut && (t === "id" || t === "name") && (r in E || r in oa))
            return !1;
          if (!(Ye && !Ze[t] && m(Jr, t))) {
            if (!(Dt && m(Qr, t))) {
              if (!H[t] || Ze[t]) {
                if (
                  // First condition does a very basic check if a) it's basically a valid custom element tagname AND
                  // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                  // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                  !(Xt(e) && (w.tagNameCheck instanceof RegExp && m(w.tagNameCheck, e) || w.tagNameCheck instanceof Function && w.tagNameCheck(e)) && (w.attributeNameCheck instanceof RegExp && m(w.attributeNameCheck, t) || w.attributeNameCheck instanceof Function && w.attributeNameCheck(t)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                  // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                  t === "is" && w.allowCustomizedBuiltInElements && (w.tagNameCheck instanceof RegExp && m(w.tagNameCheck, r) || w.tagNameCheck instanceof Function && w.tagNameCheck(r)))
                ) return !1;
              } else if (!et[t]) {
                if (!m(Ve, f(r, Mt, ""))) {
                  if (!((t === "src" || t === "xlink:href" || t === "href") && e !== "script" && g(r, "data:") === 0 && Ht[e])) {
                    if (!(Pt && !m(ea, f(r, Mt, "")))) {
                      if (r)
                        return !1;
                    }
                  }
                }
              }
            }
          }
          return !0;
        }, Xt = function(e) {
          return e !== "annotation-xml" && o(e, ta);
        }, Kt = function(e) {
          var t, r, b, Y;
          se("beforeSanitizeAttributes", e, null);
          var B = e.attributes;
          if (!(!B || it(e))) {
            var $ = {
              attrName: "",
              attrValue: "",
              keepAttr: !0,
              allowedAttributes: H
            };
            for (Y = B.length; Y--; ) {
              t = B[Y];
              var de = t, F = de.name, ot = de.namespaceURI;
              if (r = F === "value" ? t.value : O(t.value), b = W(F), $.attrName = b, $.attrValue = r, $.keepAttr = !0, $.forceKeepAttr = void 0, se("uponSanitizeAttribute", e, $), r = $.attrValue, !$.forceKeepAttr && (Ue(F, e), !!$.keepAttr)) {
                if (!Ft && m(/\/>/i, r)) {
                  Ue(F, e);
                  continue;
                }
                ve && (r = f(r, Ge, " "), r = f(r, Be, " "), r = f(r, je, " "));
                var Jt = W(e.nodeName);
                if (Yt(Jt, b, r)) {
                  if (kt && (b === "id" || b === "name") && (Ue(F, e), r = ra + r), Xe && m(/((--!?|])>)|<\/(style|title)/i, r)) {
                    Ue(F, e);
                    continue;
                  }
                  if (ae && i(Le) === "object" && typeof Le.getAttributeType == "function" && !ot)
                    switch (Le.getAttributeType(Jt, b)) {
                      case "TrustedHTML": {
                        r = ae.createHTML(r);
                        break;
                      }
                      case "TrustedScriptURL": {
                        r = ae.createScriptURL(r);
                        break;
                      }
                    }
                  try {
                    ot ? e.setAttributeNS(ot, F, r) : e.setAttribute(F, r), it(e) ? Q(e) : ne(n.removed);
                  } catch {
                  }
                }
              }
            }
            se("afterSanitizeAttributes", e, null);
          }
        }, la = function s(e) {
          var t, r = Vt(e);
          for (se("beforeSanitizeShadowDOM", e, null); t = r.nextNode(); )
            se("uponSanitizeShadowNode", t, null), Zt(t), Kt(t), t.content instanceof D && s(t.content);
          se("afterSanitizeShadowDOM", e, null);
        };
        return n.sanitize = function(s) {
          var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t, r, b, Y, B;
          if (tt = !s, tt && (s = "<!-->"), typeof s != "string" && !xe(s))
            if (typeof s.toString == "function") {
              if (s = s.toString(), typeof s != "string")
                throw L("dirty is not a string, aborting");
            } else
              throw L("toString is not a function");
          if (!n.isSupported) {
            if (i(a.toStaticHTML) === "object" || typeof a.toStaticHTML == "function") {
              if (typeof s == "string")
                return a.toStaticHTML(s);
              if (xe(s))
                return a.toStaticHTML(s.outerHTML);
            }
            return s;
          }
          if (Ke || at(e), n.removed = [], typeof s == "string" && (Re = !1), Re) {
            if (s.nodeName) {
              var $ = W(s.nodeName);
              if (!q[$] || Se[$])
                throw L("root node is forbidden and cannot be sanitized in-place");
            }
          } else if (s instanceof K)
            t = jt("<!---->"), r = t.ownerDocument.importNode(s, !0), r.nodeType === 1 && r.nodeName === "BODY" || r.nodeName === "HTML" ? t = r : t.appendChild(r);
          else {
            if (!_e && !ve && !ce && // eslint-disable-next-line unicorn/prefer-includes
            s.indexOf("<") === -1)
              return ae && Ne ? ae.createHTML(s) : s;
            if (t = jt(s), !t)
              return _e ? null : Ne ? ze : "";
          }
          t && Je && Q(t.firstChild);
          for (var de = Vt(Re ? s : t); b = de.nextNode(); )
            b.nodeType === 3 && b === Y || (Zt(b), Kt(b), b.content instanceof D && la(b.content), Y = b);
          if (Y = null, Re)
            return s;
          if (_e) {
            if (we)
              for (B = Yr.call(t.ownerDocument); t.firstChild; )
                B.appendChild(t.firstChild);
            else
              B = t;
            return (H.shadowroot || H.shadowrootmod) && (B = Kr.call(p, B, !0)), B;
          }
          var F = ce ? t.outerHTML : t.innerHTML;
          return ce && q["!doctype"] && t.ownerDocument && t.ownerDocument.doctype && t.ownerDocument.doctype.name && m(Ur, t.ownerDocument.doctype.name) && (F = "<!DOCTYPE " + t.ownerDocument.doctype.name + `>
` + F), ve && (F = f(F, Ge, " "), F = f(F, Be, " "), F = f(F, je, " ")), ae && Ne ? ae.createHTML(F) : F;
        }, n.setConfig = function(s) {
          at(s), Ke = !0;
        }, n.clearConfig = function() {
          Ee = null, Ke = !1;
        }, n.isValidAttribute = function(s, e, t) {
          Ee || at({});
          var r = W(s), b = W(e);
          return Yt(r, b, t);
        }, n.addHook = function(s, e) {
          typeof e == "function" && (oe[s] = oe[s] || [], l(oe[s], e));
        }, n.removeHook = function(s) {
          if (oe[s])
            return ne(oe[s]);
        }, n.removeHooks = function(s) {
          oe[s] && (oe[s] = []);
        }, n.removeAllHooks = function() {
          oe = {};
        }, n;
      }
      var Wr = Lt();
      return Wr;
    });
  }(St)), St.exports;
}
var Rt = {}, gr;
function Ja() {
  return gr || (gr = 1, function(u) {
    var v = Ar, i = yr;
    v(u, "__esModule", {
      value: !0
    }), u.default = void 0;
    var y = i(Ea()), I = i(Ia()), T = i(Sr()), _ = i(Rr()), P = i(Er), G = i(va), j = i(Aa()), C = i(ya()), R = i(ba()), S = i(Sa()), A = i(La()), M = i(Ca()), U = i(Ma()), Z = i(Ra()), x = i(xa()), k = i(xr());
    const ee = new y.default(), te = new y.default(), X = new y.default();
    function re(h, o) {
      var f;
      return (0, I.default)(h) || (h = [h || null]), (0, x.default)((0, Z.default)((0, T.default)(f = (0, Z.default)(h)).call(f, (g) => ((0, U.default)(g) && (g = g(o || {})), (0, A.default)(g) && (g = g.split(/\s+/g)), g))));
    }
    function le(h, o, f) {
      var g;
      return (0, I.default)(h) && (h = (0, T.default)(h).call(h, (O) => (0, M.default)(O) ? O[o] : O)), (0, M.default)(h) && (h = h[o]), (0, T.default)(g = re(h, f)).call(g, (O) => {
        if ((0, A.default)(O) && (O = {
          [O]: !0
        }), (0, M.default)(O)) {
          var m;
          return (0, _.default)(m = (0, P.default)(O).join(" ").split(/\s+/g)).call(m, (L, N) => {
            var V;
            const d = !!O[N];
            return (0, G.default)(V = N.split(/\s+/g)).call(V, (z) => {
              (0, j.default)(z).call(z, "__") !== 0 && (0, j.default)(z).call(z, "--") !== 0 && (z = `^${z.replace(/^\^/, "")}`), L[z] = d;
            }), L;
          }, {});
        }
        return (0, x.default)(O);
      });
    }
    function ne(h) {
      return h.join(" ");
    }
    function l(h) {
      return `.${h.join(".")}`;
    }
    class c {
      /**
       * Generates an Array of BEM classes
       */
      static createClassList(o, f, ...g) {
        var O;
        (0, I.default)(o) || (o = [o]), o = (0, C.default)(O = (0, T.default)(o).call(o, (L) => {
          if (!(0, A.default)(L) || (0, C.default)(L).call(L) === "")
            throw new Error(`Invalid block (${typeof L})`);
          return (0, C.default)(L).call(L);
        }).join(" ")).call(O).split(/\s+/), (!f || !(0, A.default)(f) || (0, C.default)(f).call(f) === "^") && (f = null);
        const m = [];
        return (0, G.default)(o).call(o, (L) => {
          const N = `${L}${f ? `__${f}` : ""}`;
          m.push(N), g = (0, k.default)(...(0, Z.default)(g)).split(/\s+/g), (0, G.default)(g).call(g, (V) => {
            (0, R.default)(V).call(V, "__") ? m.push(...c.create(L, V.replace(/^_{2}/, "")).split(/\s+/g)) : (0, R.default)(V).call(V, "^") ? m.push(V.replace(/^\^/, "")) : m.push(`${N}${V ? `--${V.replace(/^-{2}/, "")}` : ""}`);
          });
        }), (0, x.default)((0, S.default)(m));
      }
      /**
       * Generates a space-separated string of BEM classes
       */
      static createClassName(o, f, ...g) {
        return ne(this.createClassList(...arguments));
      }
      /**
       * Generates a CSS Selector of BEM classes
       */
      static createSelector(o, f, ...g) {
        return l(this.createClassList(...arguments));
      }
      /**
       * Alias for BEM.createClassName()
       */
      static create(o, f, ...g) {
        return this.createClassName(...arguments);
      }
      get extraClasses() {
        let o = [];
        try {
          o = [...X.get(this)];
        } catch {
        }
        return o;
      }
      /**
       * @constructor
       */
      constructor(o, f, g) {
        (0, I.default)(o) || (o = [o]);
        const O = (0, T.default)(o).call(o, (m) => {
          if (m instanceof c) {
            const L = m;
            m = ee.get(L), f = [te.get(L), f], g = [X.get(L), g];
          }
          if (!(0, A.default)(m) || (0, C.default)(m).call(m) === "")
            throw new Error(`Invalid block (${typeof m})`);
          return m;
        }).join(" ");
        ee.set(this, O), te.set(this, f || []), X.set(this, g || {});
      }
      /**
       * Generates an array of classes, using the instance
       * block, applying root modifiers, passed modifiers,
       * and extraClasses with passed data
       */
      classList(o, f, g) {
        const O = ee.get(this), m = X.get(this) || [];
        return o = o || "^", f = [...re(f, g), ...re(te.get(this), g), ...le(m, o, g)], this.constructor.createClassList(O, o, f);
      }
      /**
       * Generates a space-separated string of classes, using the instance
       * block, applying root modifiers, passed modifiers,
       * and extraClasses with passed data
       */
      className(o, f, g) {
        return ne(this.classList(...arguments));
      }
      /**
       * Generates a CSS selector of classes, using the instance
       * block, applying root modifiers, passed modifiers,
       * and extraClasses with passed data
       */
      selector(o, f, g) {
        return l(this.classList(...arguments));
      }
      /**
       * Alias for .className()
       */
      elem(o, f, g) {
        return this.className(...arguments);
      }
      /**
       * Generates a string of root classes
       *
       * Shortcut for .className('^', modifiers, data)
       */
      mod(o, f) {
        return this.className("^", o, f);
      }
    }
    u.default = c;
  }(Rt)), Rt;
}
(function(u) {
  var v = Ar, i = yr;
  v(u, "__esModule", {
    value: !0
  }), v(u, "BEM", {
    enumerable: !0,
    get: function() {
      return R.default;
    }
  }), v(u, "classNameFromObject", {
    enumerable: !0,
    get: function() {
      return j.default;
    }
  }), u.closestElement = ne, u.empty = re, u.fragFromHtml = M, u.getMaxZIndex = U, u.getStylesFromElement = x, u.getStylesFromString = Z, u.hasVerticalScrollbar = k, u.isElementInViewport = X, u.mergeElementStyles = te, u.mergeStyleStrings = ee, u.remove = le, u.sanitize = A;
  var y = i(Wa()), I = i(Rr()), T = i(Oa()), _ = i(Sr()), P = i(Er), G = i(Xa()), j = i(xr()), C = i(Ka()), R = i(Ja());
  const S = ({
    ADD_ATTR: l = [],
    ADD_TAGS: c = [],
    FORBID_ATTR: h = [],
    FORBID_TAGS: o = [],
    ...f
  }) => ({
    ...f,
    ADD_ATTR: [...l],
    ADD_TAGS: [...c, "ba-dropdown", "ba-file-icon", "ba-icon", "ba-option-group", "ba-option", "ba-select", "ba-toggle-content"],
    FORBID_ATTR: [
      ...h
      // 'style', // needs additional research
    ],
    FORBID_TAGS: [
      ...o
      // 'style', // needs additional research
    ],
    SAFE_FOR_JQUERY: !0
  });
  function A(l, c = {}) {
    return C.default.sanitize(l, S(c));
  }
  function M(l, c = {}) {
    return A(l, {
      ...c,
      RETURN_DOM_FRAGMENT: !0
    });
  }
  function U() {
    let l, c = 0;
    const h = document.getElementsByTagName("*");
    for (let o = 0, f = h.length; o < f; o++)
      l = document.defaultView.getComputedStyle(h[o], null).getPropertyValue("z-index"), l = (0, y.default)(l, 10), l < 9e4 && (c = l ? Math.max(c, l) : c);
    return c;
  }
  function Z(l) {
    const c = document.createElement("div");
    return c.style.cssText = l, x(c);
  }
  function x(l) {
    const c = {};
    for (let h = 0; h < l.style.length; h++) {
      const o = l.style.item(h);
      c[o] = l.style[o];
    }
    return c;
  }
  function k(l) {
    return l.offsetWidth - l.clientWidth > 0;
  }
  function ee(...l) {
    var c;
    const h = (0, I.default)(l).call(l, (o, f) => (0, T.default)(o, Z(f)), {});
    return (0, _.default)(c = (0, P.default)(h)).call(c, (o) => `${o}: ${h[o]}`).join(";");
  }
  window.getStylesFromString = Z, window.mergeStyleStrings = ee;
  function te(l, c) {
    var h;
    const o = [], f = (0, T.default)({}, x(l), c);
    return (0, I.default)(h = (0, P.default)(f)).call(h, (g, O) => (g.push(`${(0, G.default)(O)}: ${f[O]}`), g), o), l.style.cssText = o.join("; "), l;
  }
  function X(l) {
    const c = l.getBoundingClientRect();
    return c.bottom > 0 && c.right > 0 && c.left < window.innerWidth && c.top < window.innerHeight;
  }
  function re(l) {
    for (; l.firstChild; )
      l.removeChild(l.firstChild);
  }
  function le(l) {
    l.parentNode && l.parentNode.removeChild(l);
  }
  function ne(l) {
    return function(c) {
      do {
        if (c.nodeType === 1 && c.matches(l))
          return c;
        c = c.parentNode;
      } while (c);
    };
  }
})(Na);
export {
  Wa as a,
  Na as d,
  Ja as r
};
//# sourceMappingURL=index-DH8DM7A9.mjs.map
